var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinchDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4348_7843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7143 8.78564C13.1482 8.78564 13.5 9.13742 13.5 9.57136V11.9285C13.5 12.7964 12.7965 13.4999 11.9286 13.4999H4.07143C3.20355 13.4999 2.5 12.7964 2.5 11.9285V9.57136C2.5 9.13742 2.85178 8.78564 3.28571 8.78564C3.71965 8.78564 4.07143 9.13742 4.07143 9.57136V11.9285H11.9286V9.57136C11.9286 9.13742 12.2803 8.78564 12.7143 8.78564Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99979 2.5C8.43372 2.5 8.7855 2.85178 8.7855 3.28571V6.88883L9.80135 5.87298C10.1082 5.56615 10.6057 5.56615 10.9125 5.87298C11.2193 6.17983 11.2193 6.67731 10.9125 6.98416L7.99979 9.89687L5.08706 6.98416C4.78022 6.67731 4.78022 6.17983 5.08706 5.87298C5.39391 5.56615 5.89139 5.56615 6.19823 5.87298L7.21408 6.88883V3.28571C7.21408 2.85178 7.56586 2.5 7.99979 2.5Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4348_7843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinchDown);
export default __webpack_public_path__ + "static/media/winch-down.3a27356f837f5f9bf5abdc47ecd2b981.svg";
export { ForwardRef as ReactComponent };